<template>
    <div class="vue-vehicle-overview-cta" :class="{ 'has-custom-image': hasCustomImage }">
        <div class="vehicle-overview-cta" :style="styles">
            <div class="content-wrapper" v-html="content"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OverviewCta",

    props: {
        content: {
            type: String,
            default: '',
        },

        image: {
            type: String,
            default: '',
        }
    },

    computed: {
        hasCustomImage() {
            return this.image && this.image !== '';
        },

        styles() {
            if (!this.hasCustomImage) {
                return {}
            }

            return {
                backgroundImage: `url(${this.image})`,
            }
        }
    }
}
</script>
